import React from 'react'
import SectionWithHeading from '../../../components/SectionWithHeading/SectionWithHeading'
import { locale, t, textWithLocale } from '../../../../common/i18n'
import { CatalogoProductInfo } from './CatalogoProductInfo'

interface Props {
  producto: CatalogoProductInfo
}

export const Descripcion: React.FC<Props> = ({ producto }) => {
  const hasProductoField = producto?.producto
  const afterTitle = hasProductoField
    ? producto.producto[textWithLocale('descripcion')]
    : `${producto.nombre_producto}`.toUpperCase()

  const title =
    t('catalogo.producto.ficha.section_descripcion.title') +
    (hasProductoField ? ` ${producto.nombre_producto} -` : '')

  return (
    <SectionWithHeading title={title} afterTitle={afterTitle}>
      <p>{producto[`recomendado_para_${locale}`]}</p>
    </SectionWithHeading>
  )
}
